import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { French } from "flatpickr/dist/l10n/fr.js"

// Replaces a native datetime-local input with a flatpickr picker
// configured in French + 24h time format. Avoids browser locale issues
// (Chrome on a US-locale OS shows AM/PM despite lang="fr").
export default class extends Controller {
  connect() {
    this.fp = flatpickr(this.element, {
      enableTime:    true,
      time_24hr:     true,
      dateFormat:    "Y-m-d\\TH:i:S",  // value sent to Rails (HTML5 datetime-local format)
      altInput:      true,
      altFormat:     "j F Y · H:i",     // human display: "11 mai 2026 · 17:30"
      altInputClass: this.element.className,
      locale:        French,
      minuteIncrement: 1,
      allowInput:    false
    })
  }

  disconnect() {
    if (this.fp) this.fp.destroy()
  }
}
